export default __webpack_public_path__ + "static/media/bgimage.ed390c90.jpg";